var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ssp-empty-card"},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title || '找不到指定的数据'))]),(_vm.hint)?_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }